import React from "react";
import { Grid, Message } from "semantic-ui-react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import FlashMessageStore from "../stores/FlashMessageStore";

@observer
class FlashMessage extends React.Component {
  render() {
    const { flashMessageStore } = this.props;
    const { message, type } = flashMessageStore;

    if (message === null) {
      return null;
    }

    return (
      <Grid.Row style={{ marginBottom: "10px" }}>
        <Grid.Column width={16}>
          <Message
            info={type === "info"}
            warning={type === "warning"}
            positive={type === "positive"}
            negative={type === "negative"}
          >
            <p>{message}</p>
          </Message>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

FlashMessage.propTypes = {
  flashMessageStore: PropTypes.instanceOf(FlashMessageStore),
};

export default FlashMessage;
